import Vapi from '@borisp/vuex-rest-api'
import { getOptimisticDelete, payloadToState } from '../../utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

const getOptimisticDeleteEpisodes = itemName => (state, { data }) => {
  state[itemName] = state[itemName].filter(item => !data.episodeIdsToBeDeleted.includes(item._id))
}

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    episodes: [],
    episode: {}
  }
})
  .get({
    queryParams: true,
    action: 'getEpisodes',
    property: 'episodes',
    path: '/episodes/',
    onSuccess: payloadToState('episodes')
  })
  .post({
    action: 'createEpisode',
    property: 'episode',
    path: '/episodes/',
    onSuccess: payloadToState('episode')
  })
  .get({
    action: 'getEpisode',
    property: 'episode',
    path: ({ id }) => `/episodes/${id}`,
    onSuccess: payloadToState('episode')
  })
  .delete({
    action: 'deleteEpisode',
    property: 'episode',
    path: ({ id }) => `/episodes/${id}`,
    beforeRequest: getOptimisticDelete('episodes'),
    onSuccess: payloadToState('episode')
  })
  .patch({
    action: 'deleteEpisodes',
    property: 'episode',
    path: '/episodes/',
    beforeRequest: getOptimisticDeleteEpisodes('episodes'),
    onSuccess: payloadToState('episode')
  })
  .getStore()
